module.exports = __webpack_public_path__ + "static/media/gameoflife.f29286f5.jpg";